// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2R7bp","savePackageButton":"ClientWallet_savePackageButton__3ClBC"};